import {
  VerifierCredentialStatus,
  VerifierStaffRole,
  VerifierType,
  VerifierTypeOfGovernment,
} from 'src/api';
import { SelectFieldOption } from 'src/types/components';

export const VERIFIER_TYPE_FILTER_OPTIONS = [
  {
    value: VerifierType.Commercial,
    label: 'Commercial',
  },
  {
    value: VerifierType.Government,
    label: 'Government',
  },
] as const satisfies SelectFieldOption[];

export const VERIFIER_GOVERNMENT_OPTIONS = [
  {
    label: 'State',
    value: VerifierTypeOfGovernment.State,
  },
  {
    label: 'Federal',
    value: VerifierTypeOfGovernment.Federal,
  },
  {
    label: 'Local',
    value: VerifierTypeOfGovernment.Local,
  },
] as const satisfies SelectFieldOption[];

export const VERIFIER_ROLE_OPTIONS = [
  {
    label: 'Admin',
    value: VerifierStaffRole.VerifierAdmin,
  },
  {
    label: 'Manager',
    value: VerifierStaffRole.VerifierManager,
  },
] as const satisfies SelectFieldOption[];

export const VERIFIER_CREDENTIAL_STATUS_LABELS: Record<VerifierCredentialStatus, string> = {
  [VerifierCredentialStatus.AwaitingApprovalByCv]: 'Awaiting Approval By CV',
  [VerifierCredentialStatus.Credentialed]: 'Credentialed',
  [VerifierCredentialStatus.Denied]: 'Denied',
  [VerifierCredentialStatus.DeniedByMiddesk]: 'Denied By Middesk',
  [VerifierCredentialStatus.MiddeskPending]: 'Middesk Pending',
  [VerifierCredentialStatus.NotCredentialed]: 'Not Credentialed',
  [VerifierCredentialStatus.Referred]: 'Referred',
};
